import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { TablerIconComponent } from 'angular-tabler-icons';
import { ControlsModule } from 'src/app/controls/controls.module';
import { DeviceService } from 'src/app/core/device.service';
import { FlashcardService } from 'src/app/core/flashcard.service';
import { PremiumFeatureDialogService } from 'src/app/core/premium-feature-dialog.service';
import { UserService } from 'src/app/core/user.service';
import { Flashcard } from 'src/app/models/flashcard.model';
import { User } from 'src/app/models/user.model';
import { AiChatComponent } from 'src/app/shared/ai-chat/ai-chat.component';

@Component({
  selector: 'app-edit-flashcard',
  templateUrl: './edit-flashcard.component.html',
  styleUrls: ['./edit-flashcard.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ControlsModule,
    AiChatComponent,
    TablerIconComponent
  ]
})
export class EditFlashcardComponent {

  @Input() flashcard?: Flashcard;
  @Output() finished: EventEmitter<any> = new EventEmitter<any>();

  user?: User;
  deviceSize?: 'mobile' | 'tablet' | 'desktop';

  form?: FormGroup;
  isLoading: boolean = false;

  showAiChat: boolean = false;

  constructor(
    private fb: FormBuilder,
    private flashcardService: FlashcardService,
    private userService: UserService,
    private premiumFeatureDialogService: PremiumFeatureDialogService,
    private deviceService: DeviceService
  ) {}

  ngOnInit() {
    this.form = this.fb.group({
      front: [this.flashcard?.question, [Validators.required, Validators.minLength(1)]],
      back: [this.flashcard?.answer, [Validators.required, Validators.minLength(1)]]
    });
    this.deviceSize = this.deviceService.getDeviceSize();

    this.userService.getUser().subscribe((user) => this.user = user);
  }

  ngOnChanges() {
    if (this.flashcard) {
      this.form?.setValue({ front: this.flashcard?.question, back: this.flashcard?.answer });
    }
  }

  updateFlashcard() {
    this.isLoading = true;
    this.flashcard!.question = this.form!.value['front'];
    this.flashcard!.answer = this.form!.value['back'];
    this.flashcardService.updateFlashcards([this.flashcard!]).subscribe(() => {
      this.isLoading = false;
      this.finished.emit();
    });
  }

  generateBackContent() {
    if (this.user && this.user.isPremiumUser) {
      this.flashcardService.generateFlashcardAnswer(this.form!.get('front')!.value).subscribe(result => this.form?.setValue({front: this.form.get('front')!.value, back: result.answer}));
    } else {
      this.premiumFeatureDialogService.showDialog('Antwort mit KI erstellen lassen', 'Erstelle noch schneller die perfekten Lernkarten und lasse dir die Antwort auf deine Frage automatisch mit KI generieren.');
    }
  }

  getControl(control: string) {
    return this.form!.get(control) as FormControl;
  }
}
